import { EDDAction } from '../constants';
import { getPincodeFromCookie } from '../utils/utils.js';
import _isEmpty from 'lodash/isEmpty';

const eddDefaultValue = {
  isEDDFetching: false,
  isServiceabilityFetching: false,
  isCheckServiceabilityCalled: false,
  isCheckServiceabilityCalledForRex: false,
  errorInServiceabilityFetching: false,
  activePincode: getPincodeFromCookie(),
  eddDetails: {},
  serviceabilityDetails:{},
  // {
  //  [pincode]: {
  //     [productCode]:{
  //         "codEligible": true,
  //         "eddLower": "2019-04-08T14:29:51+0530",
  //         "eddUpper": "2019-04-10T14:29:51+0530",
  //         "productCode": "440610568029",
  //         "servicability": true
  //     }
  //   }
  //   .....
  // }
  isCartItemsEDDFetching: true,
  showPincodeModal: false,
  showMoveToClosetModal: false,
  movingAllNonDeliverableItemsToCloset: false,
  isCheckServiceabilityAPIFailed: false,
  isCheckDeliveryStatusCalled:false,
};

function edd(state = eddDefaultValue, action) {
  switch (action.type) {
    case EDDAction.SET.PINCODE_MODAL: {
      const { status } = action;
      return { ...state, showPincodeModal: status };
    }

    case EDDAction.SET.MOVE_TO_CLOSET: {
      const { status } = action;
      return { ...state, showMoveToClosetModal: status };
    }

    case EDDAction.RESET.DELIVERY_DETAILS: {
      const { productCode, isExchangeRquest } = action;
      return {
        ...state,

        eddDetails: {
          ...Object.entries(state.eddDetails).reduce(
            (updatedProductDetailsMapp, [pinCode, productDetailsMap]) => {
              let newMap = { ...updatedProductDetailsMapp, [pinCode]: {} };
              Object.entries(productDetailsMap).forEach(([pCode, details]) => {
                if (isExchangeRquest || pCode !== productCode) {
                  newMap = {
                    ...newMap,
                    [pinCode]: {
                      ...newMap[pinCode],
                      [pCode]: details
                    }
                  };
                }
              });
              return newMap;
            },
            {}
          )
        }
      };
    }

    case EDDAction.FETCH.DELIVERY_DETAILS.REQUEST: {
      const { pinCode, productCode } = action;

      function isUnservicablity(pinCodeDetails, productCode) {
        if (
          pinCodeDetails &&
          pinCodeDetails[productCode] &&
          pinCodeDetails[productCode].servicability
        ) {
          return pinCodeDetails[productCode];
        }
        return {};
      }

      return {
        ...state,
        isEDDFetching: true,
        activePincode: pinCode,
        eddDetails: {
          ...state.eddDetails,
          [pinCode]: {
            ...(state.eddDetails[pinCode] || {}),
            [productCode]: isUnservicablity(state.eddDetails[pinCode], productCode)
          }
        }
      };
    }
    case EDDAction.FETCH.DELIVERY_DETAILS.FAILURE: {
      return {
        ...state,
        isEDDFetching: false
      };
    }
    case EDDAction.FETCH.DELIVERY_DETAILS.SUCCESS: {
      const { pinCode, productDetails, servicability, productCode } = action;
      let productDeliveryDetails = productDetails.reduce((acc, product)=> {
        if(product.deliveryMethod === "STANDARD") {
          return {
            ...acc,
            ...product
          }
        } else if(product.deliveryMethod === "PRIORITY") {
          return {
            ...acc,
            priorityDelivery: product
          }
        }
        else if(product.deliveryMethod === "RUSH " || product.deliveryMethod === "RUSH") {
          return {
            ...acc,
            rushDelivery: product
          }
        }
      }, {});

      if (servicability) {
        const successStatus = {
          ...state,
          isEDDFetching: false,
          activePincode: pinCode,
          isCheckDeliveryStatusCalled: true,
          eddDetails: {
            ...state.eddDetails,
            [action.pinCode]: {
              ...(state.eddDetails[pinCode] || {}),
              [productDetails[0].productCode]: productDeliveryDetails
            }
          }
        };
        return successStatus;
      }

      const errorStaus = {
        ...state,
        isEDDFetching: false,
        activePincode: pinCode,
        eddDetails: {
          ...state.eddDetails,
          [pinCode]: {
            ...(state.eddDetails[pinCode] || {}),
            [productDetails[0].productCode]: {
              ...productDetails[0]
            }
          }
        }
      };
      return errorStaus;
    }

    case EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.REQUEST: {
      return {
        ...state,
        isServiceabilityFetching: true,
       };
    }

    case EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.SUCCESS: {
      const {
        payload: { cod = {}, returnWindow = {}, showEmi = false }
      } = action;
      const isCodEmpty = _isEmpty(cod)
      const isRexEmpty = _isEmpty(returnWindow)
      let successStatus = {};
       if (isCodEmpty && isRexEmpty) {
        console.log("cod and rex empty")
        successStatus = {
          ...state,
          isServiceabilityFetching: false,
          isCheckServiceabilityCalled: false,
          isCheckServiceabilityCalledForRex: false,
          errorInServiceabilityFetching: false,
          serviceabilityDetails: {
            ...state.serviceabilityDetails,
            cod,
            returnWindow,
            showEmi
          }
        };
      }
      else if (isCodEmpty) {
        console.log("cod empty")
        successStatus = {
          ...state,
          isServiceabilityFetching: false,
          isCheckServiceabilityCalled: false,
          isCheckServiceabilityCalledForRex: true,
          errorInServiceabilityFetching: false,
          serviceabilityDetails: {
            ...state.serviceabilityDetails,
            cod,
            returnWindow,
            showEmi
          }
        };
      } else if(isRexEmpty){
        console.log("rex empty")

        successStatus = {
          ...state,
          isServiceabilityFetching: false,
          isCheckServiceabilityCalled: true,
          isCheckServiceabilityCalledForRex: false,
          errorInServiceabilityFetching: false,
          serviceabilityDetails: {
            ...state.serviceabilityDetails,
            cod,
            returnWindow,
            showEmi
          }
        };
      } else {
        console.log("None empty")
        successStatus = {
          ...state,
          isServiceabilityFetching: false,
          isCheckServiceabilityCalled: true,
          isCheckServiceabilityCalledForRex: true,
          errorInServiceabilityFetching: false,
          serviceabilityDetails:{
            ...state.serviceabilityDetails,
            cod,
            returnWindow,
            showEmi
          }
        };
      }
      return successStatus;
    }
    case EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.FAILURE: {
      return {
        ...state,
        isServiceabilityFetching: false,
        errorInServiceabilityFetching: true
      };
    }
    case EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.REQUEST: {
      return { ...state, isCartItemsEDDFetching: true };
    }
    case EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.FAILURE: {
      return { ...state, isCartItemsEDDFetching: false };
    }
    case 'CHECK_SERVICEABILITY_API_FAILED': {
      return { ...state, isCheckServiceabilityAPIFailed: true };
    }
    case 'CHECK_SERVICEABILITY_API_SUCCESS': {
      return { ...state, isCheckServiceabilityAPIFailed: false };
    }
    case EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.SUCCESS: {
      const { productDetails, pincode, servicability, codEligible } = action;

      const nextState = {
        ...state,
        servicability,
        codEligible,
        activePincode: pincode,
        isCartItemsEDDFetching: false,
        eddDetails: {
          ...state.eddDetails,
          [pincode]: {
            // ...state.eddDetails[pinCode] || {},
            ...[...productDetails].reduce((productMap, itemEDDDetails) => {
              return {
                ...productMap,
                [itemEDDDetails.productCode]: itemEDDDetails
              };
            }, {})
          }
        }
      };
      return nextState;
    }
    case EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.REQUEST: {
      return { ...state, movingAllNonDeliverableItemsToCloset: true };
    }
    case EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.FAILURE:
    case EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.SUCCESS: {
      return { ...state, movingAllNonDeliverableItemsToCloset: false };
    }

    case EDDAction.REMOVE.NON_VELIVERABLE_ITEM: {
      const { activePincode, productCode: code } = action;
      return {
        ...state,
        eddDetails: {
          ...state.eddDetails,
          [activePincode]: Object.entries(state.eddDetails[activePincode]).reduce(
            (newOptions, [productCode, productDetails]) => {
              if (productCode.toString() !== code.toString()) {
                return {
                  ...newOptions,
                  [productCode]: productDetails
                };
              }
              return newOptions;
            },
            {}
          )
        }
      };
    }
    default:
      return state;
  }
}
export default edd;
